if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        const _this = this;
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.allStock = {};
        this.allowAddToCart = false;

        if (document.querySelector("#stockData")) {
          this.allStock = JSON.parse(
            document.querySelector("#stockData").textContent
          );
        }

        this.backorderButton = document.querySelector(
          "#PopupModal-outOfStock #outOfStockAddToCart"
        );

        this.customProperties = this.form.querySelectorAll(
          "[name*='properties']:not(.hidden-properties)"
        );

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        if (this.backorderButton) {
          this.backorderButton.addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        window.onload = function () {
          document
            .querySelector(".page-product .spinner")
            .classList.add("hidden");
          document
            .querySelector(".product-page-center")
            .classList.remove("hidden");
          document.querySelector(".MagicScroll img").style.visibility =
            "visible";
        };

        const attributeSelect = document.querySelector(
          "#attribute_toe_bug_stitching"
        );
        let originalPriceHtml = document.querySelector(
          ".product-price .price-item"
        );

        if (attributeSelect) {
          attributeSelect.addEventListener("change", (e) => {
            const val = e.target.value;
            const price = originalPriceHtml.dataset.price / 100;

            let newPrice = _this.changePriceBasedOnAttribute(price, val);

            originalPriceHtml.innerHTML = Shopify.formatMoney(newPrice * 100);
          });
        }
      }

      changePriceBasedOnAttribute(originalValue, str) {
        const match = str.match(/\(([^)]+)\)/);
        if (!match) return originalValue; // no parentheses found

        const change = parseFloat(match[1]);
        if (isNaN(change)) return originalValue; // not a valid number

        return originalValue + change;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        // console.log('this', this)
        // console.log('this.submitButton', this.submitButton)

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        console.log("formData", formData);

        config.body = formData;

        // Properties Validation
        let propertiesError = [];
        if (this.customProperties.length) {
          this.customProperties.forEach((element) => {
            const variantTitle = element.dataset.title;
            if ("null" == element.value || element.value == "") {
              propertiesError.push(variantTitle);
              return false;
            }

            return true;
          });
        }

        console.log("propertiesError1", propertiesError);

        if (propertiesError.length) {
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
          this.submitButton.removeAttribute("aria-disabled");

          let errors = propertiesError.map((e) => {
            // if(e == 'Size') {
            return "Be sure all options are selected";
            // }
          });

          propertiesError = [...new Set(errors)];

          this.handleErrorMessage(propertiesError);
          return;
        }

        let variantKey = null;
        for (var [key, value] of formData.entries()) {
          if (key == "variant_key") {
            variantKey = value;
          }
        }

        // if (discontinued == "true") {
        //   this.submitButton.classList.remove("loading");
        //   this.querySelector(".loading-overlay__spinner").classList.add(
        //     "hidden"
        //   );
        //   this.submitButton.removeAttribute("aria-disabled");

        //   // propertiesError = ["No Longer Available"];

        //   this.handleErrorMessage(propertiesError);
        //   // return;
        // }

        // console.log("formData.entries()", formData.entries());
        // console.log("variantKey", variantKey);

        let modal = document.getElementById("PopupModal-outOfStock");

        if (discontinued == "false" && modal?.hasAttribute("open")) {
          this.allowAddToCart = true;
        } else {
          this.allowAddToCart = false;
        }

        if (variantKey && !this.allowAddToCart) {
          let variant = this.allStock[variantKey];

          if (variant && discontinued == "false") {
            if (variant.qty <= 0) {
              // console.log("variant && !discontinued", variant);

              if (modal) {
                modal.show();
                // this.allowAddToCart = true;
              }

              this.submitButton.classList.remove("loading");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
              this.submitButton.removeAttribute("aria-disabled");

              return;
            }
          }
        }

        for (var pair of formData.entries()) {
          console.log(pair[0] + ", " + pair[1]);
        }

        // console.log('config', config)

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("response", response);
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // this.cart.renderContents(response); // disable cart notification
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        // console.log("errorMessage", errorMessage);
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
